// noinspection JSUnusedGlobalSymbols imported via d.ts file
import {createModalV2} from "../../../../../helpers/modals/modalV2";
import {updateProgressBar} from "../../../../../helpers/progressBar/progressBar";
import createElement from "../../../../../helpers/createElement";

// noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols -- imported via d.ts
/**
 * @param {GanttWrapper.GanttWrapper} gantt
 * @return {DisplayTaskModal.DisplayTaskModal}
 */
function createDisplayTaskModal(gantt) {
	// noinspection JSValidateTypes
	/**
	 * @type {DisplayTaskModal.DisplayTaskModal}
	 */
	const modal = createModalV2({
		// There should be only one instance of this modal on the DOM
		modalContainer: document.querySelector('.timeline-tasks-display-modal'),
		init() {
		}
	});

	// Override display function to setup on display
	// noinspection JSUndefinedPropertyAssignment
	modal._og_display = modal.display;

	modal.display = (task, firstTime = true) => {
		// Save task
		modal.currentTask = task;

		renderModal();

		// noinspection JSUnresolvedReference
		modal._og_display(firstTime);
	}

	// Get templates
	return modal;

	// Methods
	/**
	 * Gets called to update the modal's DOM with the new task data
	 */
	function renderModal() {
		const dateFormat = 'MM/DD/YYYY';
		const task = modal.currentTask;

		// Update modal name
		modal.modalContainer.querySelector('.modal-title').innerText =
			`${task.name}`;

		// Update progress bar
		updateProgressBar(
			modal.modalContainer.querySelector('.component-progress-bar'),
			task.progress,
		)

		// Update fields
		const fieldMap = [
			{
				className: 'task-start-date',
				getter() {
					return gantt._getCurrentStartDate(task).format(dateFormat)
				}
			},
			{
				className: 'task-end-date',
				getter() {
					return gantt._getCurrentEndDate(task).format(dateFormat)
				}
			},
			{
				className: 'task-work-days',
				getter() {
					const delayedDays = gantt._getTaskDelayedDays(task);
					const duration = gantt._getTaskActualDuration(task)

					if (delayedDays > 0) {
						return `
							${duration - delayedDays}
							<span
								class="text-warning cursor-help"
								title="Delayed Days"
							>
								+ ${delayedDays}
							</span>
						`
					} else {
						return duration;
					}
				}
			},
		]

		fieldMap.forEach(fieldData => {
			modal.modalContainer.querySelectorAll(`.${fieldData.className}`)
				.forEach(element => {
					element.innerHTML = fieldData.getter();
				})
		})

		// Clear delays container
		const delaysContainer = modal.modalContainer.querySelector('.delays-container');

		delaysContainer.querySelectorAll('.delay-container').forEach(delay => {
			delay.remove();
		})

		const emptyMessage = delaysContainer.querySelector('.empty-message');

		// Display delays
		if (task.delays.length > 0) {
			emptyMessage.classList.add('d-none');

			task.delays.forEach(delay => {
				delaysContainer.appendChild(createElement(`
					<div class="delay-container border rounded px-2 py-1 mb-2">
						<div class="row">
							<div class="col-10">
								${delay.reason}
							</div>
							<div class="col-2 text-right">
								${delay.duration} Day${delay.duration > 1 ? 's' : ''}
							</div>
						</div>
						<div class="row">
							<div class="col pl-4 text-muted">
								${delay.description}
							</div>
						</div>
						<div class="row">
							<div class="col text-right text-muted small">
								${delay.startDate ? delay.startDate.format(dateFormat) : ''}
							</div>
						</div>
					</div>
				`));
			})
		} else {
			emptyMessage.classList.remove('d-none');
		}
	}

}

export {createDisplayTaskModal}
